/**
 * Created by slava on 23/11/17
 */

cleverapps.MiniGame = function (isNewUser) {
    if (cleverapps.config.debugMode) {
        cleverapps.MiniGame.TIMEOUT = "2 minutes";
    }

    cleverapps.DailyChest.call(this, {
        isNewUser,
        serverTaskName: "bonuses",
        interval: cleverapps.parseInterval(cleverapps.MiniGame.TIMEOUT)
    });
};

cleverapps.MiniGame.prototype = Object.create(cleverapps.DailyChest.prototype);
cleverapps.MiniGame.prototype.constructor = cleverapps.MiniGame;

cleverapps.MiniGame.prototype.initializeForNewUser = function () {
    this.locked = false;
    this.setWhenUnlock(Date.now());
};

cleverapps.MiniGame.TIMEOUT = "1 day";

cleverapps.MiniGame.prototype.resetUnlockCountdown = function () {
    cleverapps.DailyChest.prototype.resetUnlockCountdown.call(this);

    PushHelper.sendPush(PUSHES.MINI_GAME, this.when - Date.now());
};

cleverapps.MiniGame.prototype.refreshItems = function () {

};

cleverapps.MiniGame.prototype.isAvailable = function () {
    if (!levels.user.checkAvailable(cleverapps.config.availables.MINIGAME)) {
        return false;
    }

    return !this.locked;
};

cleverapps.MiniGame.prototype.getReward = function () {
    let prize = PseudoRandom.GET().choose(RewardsConfig.MiniGame);
    if (levels.user.isBeginner() && RewardsConfig.MiniGameBeginner) {
        prize = PseudoRandom.GET().choose(RewardsConfig.MiniGameBeginner);
    }
    if (levels.user.isNovice() && RewardsConfig.MiniGameNovice) {
        prize = PseudoRandom.GET().choose(RewardsConfig.MiniGameNovice);
    }

    if (prize.betGold) {
        delete prize.betGold;
    }

    prize = cleverapps.user.prepareRewardByRich(prize);

    return prize;
};
